import type {MilestonePickerMilestoneItem} from '@github-ui/item-picker-milestone'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type GetSearchMilestonesRequest = {
  owner: string
  repo: string
}

export type GetMilestonePickerSearchResponse = {
  data: {
    repository: {
      id: string
      milestones: {
        nodes: MilestonePickerMilestoneItem[]
      }
    }
  }
}

export async function apiGetSearchMilestones({
  owner,
  repo,
}: GetSearchMilestonesRequest): Promise<GetMilestonePickerSearchResponse> {
  const requestUrl = buildItemPickerSearchUrl('milestones', {owner, repo})
  const request = await verifiedFetchJSON(requestUrl)
  return (await request.json()) as GetMilestonePickerSearchResponse
}

const itemPickersUrlBase = '/_ghui/item_pickers'

function buildItemPickerSearchUrl(endpoint: 'milestones', params = {}) {
  const paramsString = new URLSearchParams(params).toString()
  return `${itemPickersUrlBase}/${endpoint}${paramsString && `?${paramsString}`}`
}
